import { errorlog } from '@/libs/error-logs';
import { toError } from '@/utils/errors';

import { POST } from './base';
import { ENDPOINTS } from './endpoints';
import { SignGradeV2 } from './grade';

export async function saveInsightsDrGrade(grade: SignGradeV2) {
  try {
    const response = await POST(ENDPOINTS.INSIGHTS_DR_GRADES, { ...grade, _v: 2 });
    return response;
  } catch (error) {
    errorlog(
      error as Error,
      'src/api/insigths/saveInsightsDrGrade',
      'Error saving insights DR grade'
    );
    return Promise.reject(toError(error));
  }
}
